import { Button, DropDownInput } from "@/components";
import { useState } from "react";
import { HiOutlineDownload, HiOutlineUpload } from "react-icons/hi";
import { SheetClose } from "@/components/ui/sheet";
import { UploadInput } from "@/components";
import { useDispatch, useSelector } from "react-redux";
import { uploadWeightDispute } from "../../../app/Slices";
import { useAlert, useConfirmationDialog } from "@/";
const UpdateWeightDispute = ({ setSheetOpen = () => {} }) => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const handleChange = (key, value) => {
    setSelectedFile((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedFile, setSelectedFile] = useState({
    weightDispute: null,
  });
  const handleUpload = async () => {
    if (!selectedFile.weightDispute) {
      await alert("Please select a file before uploading.");
      return;
    }

    await confirm("Are you sure you want to upload Weight Dispute?");
    try {
      const action = await dispatch(
        uploadWeightDispute({ file: selectedFile.weightDispute })
      );

      if (uploadWeightDispute.fulfilled.match(action)) {
        await alert("Weight Dispute Uploaded Successfully");
        // Only close sheet after alert is acknowledged
        setSheetOpen(false);
      } else {
        console.error("Weight Dispute Upload Failed", action.payload);
        await alert(action.payload || "Weight Dispute Upload Failed");
      }
    } catch ({ error }) {
      console.error("API Error:::", error.message);
      await alert("An error occurred while uploading the Weight Dispute.");
    }
  };
  return (
    <div className="flex flex-col gap-10 pl-2">
      <div className="flex flex-col gap-6">
        {/* Step 1 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">1.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Download sample Weight Dispute sheet
            </p>
          </div>
          <div className="flex gap-2 justify-start items-center ml-6">
            <Button
              variant="default"
              size="sm"
              icon={HiOutlineDownload}
              onClick={() => {
                window.location.href =
                  "https://api.indiancouriercompany.com/samples/Admin_Weight_Dispute_Upload.csv";
              }}
            >
              Sample Sheet
            </Button>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-secondary">2.</span>
            <p className="text-subtitle2 font-bold text-secondary/95">
              Upload updated Weight Dispute sheet
            </p>
          </div>
          <div className="flex gap-2 justify-center items-center ml-6">
            <UploadInput
              label=""
              placeholder="Upload Weight Dispute Sheet"
              note="Note: Only .csv file is allowed"
              accept=".csv"
              onChange={(file) => handleChange("weightDispute", file)}
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-2 justify-end items-center mt-4">
        <SheetClose asChild>
          <Button variant="outline" size="sm">
            Cancel
          </Button>
        </SheetClose>

        <Button
          variant="default"
          size="sm"
          icon={HiOutlineUpload}
          onClick={handleUpload}
        >
          Upload Weight Dispute
        </Button>
      </div>
      <ConfirmationModal />
      <AlertDialog />
    </div>
  );
};

export default UpdateWeightDispute;
